import { render } from "./ExploreSpeeds.vue?vue&type=template&id=a27bafe2&ts=true"
import script from "./ExploreSpeeds.vue?vue&type=script&lang=ts"
export * from "./ExploreSpeeds.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__